
import { Link } from "react-router-dom";
import ProfileAvatar from "../../../../common/avatar/ProfileAvatar";
import FreeBadge, { isFreeProduct } from "../../../../common/badge/FreeBadge";
import CatalogCoverImage from "../../../../common/catalog/CatalogCoverImage";
import { resolveCatalogInstructor } from "../../../../common/catalog/catalogInstructorDisplay";

export default function Webinar({ webinar }) {
	const instructor = resolveCatalogInstructor(webinar);
	const maxLen = 50;
	const title = webinar.title.length > maxLen ? webinar.title.slice(0, maxLen) + "..." : webinar.title;

	return (
		<Link to={`/webinar_detail/${webinar.id}/`} className="no-underline h-full">
			<div className="relative flex flex-col bg-white rounded-xl border border-[#E2E8F0] p-3 h-full hover:border-darkBlue/20 hover:shadow-[0_4px_12px_rgba(39,106,166,0.08)] transition-shadow">
				{isFreeProduct(webinar) && <FreeBadge className="absolute right-[18px] top-[18px] z-10" />}
				{webinar.image_url && (
					<>
						<CatalogCoverImage src={webinar.image_url} alt={webinar.title} />
						<div className="spacer p-[10px]"></div>
					</>
				)}
				<div className="font-Vazir-700 text-[16px] text-midGray">{title}</div>
				<div className="spacer p-[5px]"></div>
				<div className="flex flex-row items-center mt-auto">
					<ProfileAvatar
						imageUrl={instructor.avatarUrl}
						name={instructor.isEmpty ? "" : instructor.subtitle}
						size="md"
					/>
					<div className="spacer p-[5px]"></div>
					<div>
						<div
							className={[
								"text-[14px]",
								instructor.isEmpty
									? "font-Vazir-400 text-darkBlue/45"
									: "font-Vazir-300 text-darkBlue",
							].join(" ")}
						>
							{instructor.subtitle}
						</div>
						<div className="spacer p-[2px]"></div>
						<div className="font-Vazir-300 text-[14px] text-darkBlue" dir="ltr">{webinar.j_create_date}</div>
					</div>
				</div>
			</div>
		</Link>
	)
}
